import React from "react";
import PropTypes from "prop-types";

const StakeholdersSection = ({ stakeholders }) => {
  return (
    <section className="py-6 md:py-10 lg:py-14 bg-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-bold mb-4 md:mb-6">
            <span className="text-[#1A2B6D]">Our Digital </span>
            <span className="text-[#1a6bbf]">Health Capabilities</span>
          </h2>
          <p className="text-[#1A2B6D] max-w-4xl mx-auto">
            Comprehensive, secure, and scalable digital solutions designed to
            modernize healthcare delivery and patient experiences.
          </p>
        </div>

        {/* Cards Grid - Light Blue Background */}
        <div className="bg-[#F0F5FF] py-8 md:py-10 lg:py-12 px-4 md:px-6 rounded-2xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6 max-w-6xl mx-auto">
            {stakeholders.map((stakeholder, index) => (
              <div
                key={index}
                className="group relative rounded-lg overflow-hidden shadow-lg h-56 md:h-60 cursor-pointer transition-all duration-300"
              >
                {/* Background Image (Visible by default) */}
                <div className="absolute inset-0">
                  <img
                    src={stakeholder.image}
                    alt={stakeholder.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>

                {/* Blue Overlay + Content 
                   Default: opacity-0 (Hidden)
                   Hover: opacity-90 (Visible)
                */}
                <div className="absolute inset-0 bg-[#1A2B6D] opacity-0 group-hover:opacity-90 transition-opacity duration-300 flex flex-col items-center justify-center p-4 md:p-5 text-white text-center">
                  
                  {/* Title with centered underline */}
                  <div className="mb-3 flex flex-col items-center">
                    <h4 className="text-white font-medium">
                      {stakeholder.title}
                    </h4>
                    <div className="w-12 h-0.5 bg-white mt-1"></div>
                  </div>

                  {/* Description */}
                  <p className="text-white  leading-relaxed para2">
                    {stakeholder.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

StakeholdersSection.propTypes = {
  stakeholders: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default StakeholdersSection;